export const Props = () => ({
  //Имя иконки
  iconName: {
    type: String,
    required: false,
  },

  //Заголовок
  title: {
    type: String,
    required: false,
  },

  //Текст
  text: {
    type: String,
    required: false,
  }
});
